import { render, staticRenderFns } from "./Printer.vue?vue&type=template&id=390602b4&scoped=true&"
import script from "./Printer.vue?vue&type=script&lang=js&"
export * from "./Printer.vue?vue&type=script&lang=js&"
import style0 from "../../../../../src/assets/css/shop-console.css?vue&type=style&index=0&id=390602b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "390602b4",
  null
  
)

export default component.exports